export const kycCompanyTaxResidencyDocConstants = {
  TAX_RESIDENCY_DOC_LIST_LOADING: 'TAX_RESIDENCY_DOC_LIST_LOADING',
  TAX_RESIDENCY_DOC_LIST_SUCCESS: 'TAX_RESIDENCY_DOC_LIST_SUCCESS',
  TAX_RESIDENCY_DOC_LIST_FAILURE: 'TAX_RESIDENCY_DOC_LIST_FAILURE',

  TAX_RESIDENCY_DOC_CREATE_LOADING: 'TAX_RESIDENCY_DOC_CREATE_LOADING',
  TAX_RESIDENCY_DOC_CREATE_SUCCESS: 'TAX_RESIDENCY_DOC_CREATE_SUCCESS',
  TAX_RESIDENCY_DOC_CREATE_FAILURE: 'TAX_RESIDENCY_DOC_CREATE_FAILURE',

  TAX_RESIDENCY_DOC_EDIT_LOADING: 'TAX_RESIDENCY_DOC_EDIT_LOADING',
  TAX_RESIDENCY_DOC_EDIT_SUCCESS: 'TAX_RESIDENCY_DOC_EDIT_SUCCESS',
  TAX_RESIDENCY_DOC_EDIT_FAILURE: 'TAX_RESIDENCY_DOC_EDIT_FAILURE',

  TAX_RESIDENCY_DOC_DELETE_LOADING: 'TAX_RESIDENCY_DOC_DELETE_LOADING',
  TAX_RESIDENCY_DOC_DELETE_SUCCESS: 'TAX_RESIDENCY_DOC_DELETE_SUCCESS',
  TAX_RESIDENCY_DOC_DELETE_FAILURE: 'TAX_RESIDENCY_DOC_DELETE_FAILURE',

  TAX_RESIDENCY_DOC_ERROR_RELOAD: 'TAX_RESIDENCY_DOC_ERROR_RELOAD'
};
